export default __webpack_public_path__ + "static/media/blank-poster.6954abbf.jpeg";